import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useI18n } from "../../../i18n";
import { api } from "../../../lib/api";
import { useApi } from "../../customer/hooks";
import { AreaCard } from "./AreaCard";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select";

const Assignments = ({ areas }) => {
  const { t, lang } = useI18n();
  const qc = useQueryClient();
  const q = useApi("deliveryAssignments", "/delivery/assignments");
  const assign = async (code, area_code) => {
    try {
      await api.put(`/delivery/assignments/${code}`, { area_code });
      qc.invalidateQueries({ queryKey: ["deliveryAssignments"] });
      toast.success(t("admin.saved"));
    } catch (e) { toast.error(t("common.error")); }
  };
  return (
    <ul className="divide-y divide-slate-100 rounded-2xl bg-white px-4 shadow-sm" data-testid="area-assignments">
      {(q.data || []).map((a) => (
        <li key={a.customer_code} className="flex flex-wrap items-center gap-3 py-3" data-testid={`assignment-${a.customer_code}`}>
          <div className="min-w-0 flex-1"><p className="text-sm font-semibold text-navy">{a.customer_name}</p><p className="text-xs text-slate-500">{a.customer_code} · {t("admin.softoneArea")}: {a.customer_area}</p></div>
          <Select value={a.area_code} onValueChange={(v) => assign(a.customer_code, v)}>
            <SelectTrigger className="h-11 w-48 rounded-xl" data-testid={`assignment-select-${a.customer_code}`}><SelectValue /></SelectTrigger>
            <SelectContent>{areas.map((ar) => <SelectItem key={ar.code} value={ar.code}>{ar[`name_${lang}`]}</SelectItem>)}</SelectContent>
          </Select>
        </li>
      ))}
    </ul>
  );
};

export default function DeliveryAdmin() {
  const { t } = useI18n();
  const areas = useApi("deliveryAreas", "/delivery/areas");
  return (
    <div className="space-y-8" data-testid="delivery-admin">
      <div><h1 className="text-3xl font-bold text-navy">{t("admin.deliveryTitle")}</h1><p className="mt-1 text-sm text-slate-500">{t("admin.deliverySub")}</p></div>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">{(areas.data || []).map((a) => <AreaCard key={`${a.code}-${a.cutoff}-${a.weekdays.join()}-${a.holidays.join()}`} area={a} />)}</div>
      <section className="space-y-3">
        <div><h2 className="text-base font-semibold text-navy md:text-lg">{t("admin.assignments")}</h2><p className="text-xs text-slate-500">{t("admin.assignmentsSub")}</p></div>
        <Assignments areas={areas.data || []} />
      </section>
    </div>
  );
}
